export default __webpack_public_path__ + "static/media/ic-ViewMovil2.320d692f.png";